<label for="{{ id }}">{{ label }}</label>
<br>
<input
  #datePicker
  id="{{ id }}"
  [class.invalid]="errorMessages?.length > 0"
  [attr.aria-label]="label"
  [attr.aria-disabled]="disabled"
  class="ods-text-input date-input"
  type="date"
  [attr.min]="min"
  [attr.max]="max"
  autocomplete="off"
  tabindex="0"
  [disabled]="disabled"
  [readOnly]="readonly"
  [valueAsDate]="selectedDate"
  (change)="selectionChanged($event.target.value)"
  (blur)="selectionChanged($event.target.value)"
/>

@if(invalid) {
  <p #errorMessage class="error-message">Enter a valid date</p>
}
@else if(touched && formControl.getError('before')) {
  <p #errorMessage class="error-message">{{ minDateErrorMessage }}</p>
}
@else if(touched && formControl.getError('after')){
  <p #errorMessage class="error-message">Date cannot be a future date</p>
}
@else if(!pristine || touched) {
  @if(minDate && showMinDateErrorMessage) {
    <p #errorMessage class="error-message">{{ minDateErrorMessage }}</p>
  }
  @else if((maxDate && showMaxDateErrorMessage) || showErrorDynamically) {
    <p #errorMessage class="error-message">{{ maxDateErrorMessage }}</p>
  }
  @else if(required) {
    @if (displayEmptyMessage) {
      <p #errorMessage class="error-message">{{ emptyDateMessage }}</p>
    }
    @else if(showInvalidDateMessage && !displayEmptyMessage) {
      <p #errorMessage class="error-message">Enter a valid date</p>
    }
  }
}

